import React from 'react';

import { ReactComponent as AddIcon } from '@assets/svg/add.svg';

import Header from '@components/common/Header/Header';
import Button from '@components/uikit/Button/Button';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import TableFacilityGroups from './components/TableFacilityGroups/TableFacilityGroups';
import { selectSearchGroup, useManageFacilityStoreActions } from './store/useManageFacilityStore';
import style from './style.module.scss';
import { Navigate } from 'react-router-dom';

const ManageFacility = () => {
  const { t } = useTranslation();

  const { setActiveModal } = useModalActions();
  const { setSearchGroup } = useManageFacilityStoreActions();
  const searchGroup = selectSearchGroup();

  if (IS_PROD) { // TODO: Remove once "Manage Facility Group" Phase 2 is completed.
    return <Navigate to="/" replace={true} />;
  }

  return (
    <>
      <Header
        title={t('Manage Facility Group')}
        showLogo={true}
        headerRightComponent={
          <Button
            text={t('Create group')}
            onClick={() => setActiveModal({ name: MODAL_NAMES.createEditFacilityGroupModal })}
            type="secondary"
            leftElement={<AddIcon className={style.createGroupIcon} />}
            dataQa="add-ai-button"
          />
        }
        extraInfo={
          <FilterSearch
            value={searchGroup}
            onChange={setSearchGroup}
            variant={'header-search'}
            placeholder={t('Start to type...')}
          />
        }
      />
      <div className={style.manageFacility}>
        <TableFacilityGroups />
      </div>
    </>
  );
};

export default ManageFacility;
